import React from "react"
import UnderProgress from "./UnderProgress"


const Tools = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <UnderProgress />
    </div>
  )
}

export default Tools
